/* =============================================================
 * import
 * ========================================================== */
import $ from "jquery";
import {mediaQuery} from '../modules/common';
import {eventObserver} from "../modules/eventObserver";

/* =============================================================
 * function
 * ========================================================== */

export default function exe() {
  slideDownBtn();

  window.addEventListener('resize', function() {
    if (mediaQuery() !== 'sp') {
      slideDownBtn();
    }
  });

  window.addEventListener("orientationchange", function() {
    if (mediaQuery() !== 'sp') {
      slideDownBtn();
    }
  });
}

function slideDownBtn() {
  const listeners = [];
  const btn = $(".category_selected");
  const area = $(".category_box");
  const obj = {
    btn: btn,
    area: area,
  };
  const slide = (e) => {
    e.data.btn.toggleClass('open');
    e.data.area.toggleClass('open').stop().slideToggle();
  };

  if (btn.length) {
    if (mediaQuery() === 'sp') {
      btn.on('click', obj, slide);
      listeners.push([btn, 'click', slide, '$']);
    } else {
      btn.off('click', slide); // リサイズイベントで再実行される可能性があるため、PCサイズでは明示的に解除
    }
  }

  eventObserver.observeEvents(listeners);
}
